import React from 'react';
import SoilResult from "./SoilResult";

class CubeCalculator extends React.Component {
    constructor(props) {
        super(props);

        // Contains length, width and height as cm.
        this.state = {
            length: 0,
            width: 0,
            height: 0
        };

        this.getVolume = this.getVolume.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
    }

    /**
     * Return the volume of the cube in m3
     *
     * @returns {number}
     */
    getVolume()
    {
        return (this.state.length * this.state.width * this.state.height) / 1_000_000;
    }

    handleFormChange(event)
    {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    render() {
        let results = '';
        let volume = this.getVolume();
        if (volume > 0){
            results = <SoilResult m3={volume} />;
        }

        return <div>
            <p>Vul onderstaande gegevens in om de inhoud en benodigde hoeveel potgrond te berekenen. Geef alle maten op in cm.</p>

            <div className="inline-form">
                <div className="form-group">
                    <label htmlFor="length">Lengte</label>
                    <input type="number" min="0" value={this.state.length} name="length" onChange={this.handleFormChange} />
                </div>
                <div className="form-group">
                    <label htmlFor="width">Breedte</label>
                    <input type="number" min="0" value={this.state.width} name="width" onChange={this.handleFormChange} />
                </div>
                <div className="form-group">
                    <label htmlFor="width">Hoogte</label>
                    <input type="number"  min="0" value={this.state.height} name="height" onChange={this.handleFormChange} />
                </div>
            </div>

            { results }
        </div>
    }
}

export default CubeCalculator;